import * as types from "./mutation-type.js";
import { storeInfoCrypt } from "../utils/storeInfoCrypt";

export default {
  [types.SET_USERINFO](state, userInfo) {
    state.userInfo = userInfo;
    storeInfoCrypt(state);
  },
  [types.SET_ISLOADING](state, isLoading) {
    state.isLoading = isLoading;
    storeInfoCrypt(state);
  },
  [types.SET_TOKEN](state, token) {
    state.token = token;
    storeInfoCrypt(state);
  },
  [types.SET_CARTITEMDATA](state, cartItemData) {
    state.cartItemData = cartItemData;
    storeInfoCrypt(state);
  },
  [types.SET_SHOWLOGINMODEL](state, isShowLoginModel) {
    state.isShowLoginModel = isShowLoginModel;
    storeInfoCrypt(state);
  },
  [types.SET_AUCTIONRECORDITEM](state, auctionRecordItem) {
    state.auctionRecordItem = auctionRecordItem;
    storeInfoCrypt(state);
  }
};
